var _defs, _circle, _g, _g2, _g3, _g4, _rect, _rect2, _path, _g5, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "no_profiles_svg__a",
    width: 112,
    height: 123,
    x: 57,
    y: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_profiles_svg__b",
    width: 124,
    height: 141,
    x: 37,
    y: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_profiles_svg__c",
    width: 119,
    height: 150,
    x: 30.003,
    y: 37.999,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_profiles_svg__d",
    width: 58,
    height: 58,
    x: 151,
    y: 4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0d2976",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "result1"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.702,
    cy: 101.225,
    r: 100,
    fill: "#eef755"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_profiles_svg__a)",
    transform: "translate(-.298 1.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 87,
    fill: "#c8d5ff",
    rx: 6,
    transform: "translate(75 58)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_profiles_svg__b)",
    transform: "translate(-.298 1.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 105,
    fill: "#c8d5ff",
    rx: 6,
    transform: "translate(55 50)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_profiles_svg__c)",
    transform: "translate(-.295 1.224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 120,
    fill: "#fff",
    rx: 6,
    transform: "translate(45 43)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#0d2976",
    transform: "translate(58.736 134.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 6,
    opacity: 0.102,
    rx: 2,
    transform: "translate(-.034 -.307)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 5,
    opacity: 0.102,
    rx: 2,
    transform: "translate(11.966 8.693)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 18,
    fill: "#f6fba9",
    rx: 9,
    transform: "translate(60.702 57.226)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 69.702,
    y: 83.225,
    fill: "#4b75ff",
    rx: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.782 107.74v3.75q0 .267-.177.444t-.413.177H86.44q-.266 0-.473-.177-.177-.177-.177-.443v-3.75q0-.237.177-.414.207-.207.473-.207h3.75q.237 0 .414.207.177.177.177.413zm4.932-9.362q0 1.063-.295 1.89-.295.798-.945 1.418-.62.59-1.063.886-.414.295-1.182.738-.65.355-1.092 1.034-.414.65-.414 1.034 0 .265-.207.502-.177.236-.413.236h-3.75q-.237 0-.414-.295-.148-.296-.148-.591v-.709q0-1.3 1.004-2.451 1.034-1.152 2.245-1.683.945-.443 1.3-.857.383-.443.383-1.181 0-.65-.738-1.152-.709-.502-1.654-.502-1.004 0-1.683.443-.532.384-1.684 1.801-.147.266-.472.266-.177 0-.384-.147l-2.57-1.92q-.442-.354-.147-.857 2.51-4.134 7.235-4.134 2.629 0 4.844 1.83 2.244 1.832 2.244 4.401z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_profiles_svg__d)",
    transform: "translate(-.298 1.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#ff7181",
    rx: 20,
    transform: "translate(160 10)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182.308 31.725l3.909-3.909a1.229 1.229 0 000-1.737l-.87-.869a1.229 1.229 0 00-1.736 0l-3.91 3.91-3.908-3.91a1.229 1.229 0 00-1.737 0l-.87.87a1.229 1.229 0 000 1.736l3.91 3.91-3.91 3.908a1.229 1.229 0 000 1.737l.87.87a1.229 1.229 0 001.737 0l3.909-3.91 3.909 3.91a1.229 1.229 0 001.737 0l.869-.87a1.229 1.229 0 000-1.737z"
  })));
}
export default SvgNoProfiles;